import { Container, Text, Anchor, Stack, SimpleGrid, Divider } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useOSD } from '../../../contexts/OSDContext';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { currentOSD, getOSDPath } = useOSD();

  return (
    <footer style={{ borderTop: '1px solid var(--ec-border-subtle, #dee2e6)', backgroundColor: 'var(--ec-footer-bg, #f8f9fa)', padding: '3rem 0 2rem' }}>
      <Container size="xl">
        <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="xl">
          {/* Brand */}
          <div>
            <Text fw={700} size="lg" c="ecoGreen.6" mb="sm">
              Taryfy Prądu
            </Text>
            <Text size="sm" c="dimmed">
              Darmowa porównywarka taryf energetycznych.
              Sprawdź, czy możesz oszczędzić na rachunkach za prąd.
            </Text>
          </div>

          {/* Przewodnik - PROMINENT since hidden from main nav */}
          <div>
            <Text fw={600} size="sm" mb="sm" tt="uppercase" c="dimmed">
              Przewodnik
            </Text>
            <Stack gap="xs">
              <Anchor component={Link} to={currentOSD ? getOSDPath('/przewodnik/taryfy') : '/przewodnik/taryfy'} size="sm" c="dark">
                Porównanie taryf
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/przewodnik/wzorce') : '/przewodnik/wzorce'} size="sm" c="dark">
                Wzorce zużycia
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/przewodnik/analizy') : '/przewodnik/analizy'} size="sm" c="dark">
                Analizy
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/przewodnik/faq') : '/przewodnik/faq'} size="sm" c="dark">
                Najczęstsze pytania (FAQ)
              </Anchor>
            </Stack>
          </div>

          {/* Narzędzia */}
          <div>
            <Text fw={600} size="sm" mb="sm" tt="uppercase" c="dimmed">
              Narzędzia
            </Text>
            <Stack gap="xs">
              <Anchor component={Link} to={currentOSD ? getOSDPath('/kalkulatory/podstawowy') : '/kalkulatory/podstawowy'} size="sm" c="dark">
                Kalkulator szczegółowy
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/kalkulatory/zaawansowany') : '/kalkulatory/zaawansowany'} size="sm" c="dark">
                Kalkulator profesjonalny
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/konto/import') : '/konto/import'} size="sm" c="dark">
                Import danych z licznika
              </Anchor>
              <Anchor component={Link} to={currentOSD ? getOSDPath('/aktualnosci') : '/aktualnosci'} size="sm" c="dark">
                Aktualności
              </Anchor>
              <Anchor href="/rss.xml" target="_blank" size="sm" c="dark">
                Kanał RSS
              </Anchor>
            </Stack>
          </div>

          {/* Informacje */}
          <div>
            <Text fw={600} size="sm" mb="sm" tt="uppercase" c="dimmed">
              Informacje
            </Text>
            <Stack gap="xs">
              <Anchor component={Link} to="/kontakt" size="sm" c="dark">
                Kontakt
              </Anchor>
              <Anchor component={Link} to="/privacy-policy" size="sm" c="dark">
                Polityka prywatności
              </Anchor>
              <Anchor component={Link} to="/terms" size="sm" c="dark">
                Regulamin
              </Anchor>
              <Anchor
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                c="dark"
              >
                Platforma ODR
              </Anchor>
            </Stack>
          </div>
        </SimpleGrid>

        <Divider my="xl" />

        <Text size="xs" c="dimmed" ta="center">
          © {currentYear} Taryfy Prądu. Wszystkie prawa zastrzeżone.
        </Text>

        <Text size="xs" c="dimmed" ta="center" mt="md" maw={800} mx="auto">
          <strong>Ważna informacja:</strong> Taryfy Prądu jest niezależną platformą
          porównawczą. Nie jesteśmy powiązani, sponsorowani ani zatwierdzeni przez
          TAURON®, PGE®, ENEA®, ENERGA® ani żadnych innych dostawców energii
          elektrycznej w Polsce. Wszelkie znaki towarowe, logo i nazwy firm są
          własnością ich prawnych właścicieli i są używane wyłącznie w celach
          informacyjnych w ramach porównania cen energii.
        </Text>
      </Container>
    </footer>
  );
}
